var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", {
        directives: [
          {
            name: "html-safe",
            rawName: "v-html-safe",
            value: _vm.displayContent,
            expression: "displayContent"
          },
          {
            name: "show",
            rawName: "v-show",
            value: _vm.readOnly && !_vm.isEmpty(_vm.editor_data),
            expression: "readOnly && !isEmpty(editor_data)"
          }
        ],
        staticClass: "editor_data editor-content ck-content",
        attrs: { id: "editorData" }
      }),
      _vm.readOnly && _vm.isEmpty(_vm.editor_data)
        ? _c("div", { staticClass: "editor_data" })
        : _vm._e(),
      _vm.editor && !_vm.readOnly
        ? _c("ckeditor", {
            key: _vm.editorKey,
            ref: "editor",
            attrs: { editor: _vm.editor, config: _vm.editorConfig },
            on: { destroy: _vm.onDestroy, ready: _vm.onReady },
            model: {
              value: _vm.editor_data,
              callback: function($$v) {
                _vm.editor_data = $$v
              },
              expression: "editor_data"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }